import React from 'react';
import GeoWorkspace from '../shared/GeoWorkspace.jsx';
export default function CEOGeoWorkspace(props) { return <GeoWorkspace role="CEO" {...props}/>; }
